import { LatLng } from "geolocation-utils";

import { IPlace, Iterable } from "types";

export const getRouteCoordinates = (place?: Iterable<IPlace>): LatLng => {
  if (!place) return { lat: 0, lng: 0 };

  return place.replacement_coordinates
    ? place.replacement_coordinates.location
    : { lat: place.latitude, lng: place.longitude };
};
